<template>
    <DatatablePageLayout>
        <template v-slot:actionButtons>
            <button class="sk-btn sk-btn-primary rounded-lg" @click="handleCreate">
                {{ $t('apps.campaigns.form.createButton') }}
            </button>
        </template>
        <template v-slot:datatable>
            <DataTable
                :config="datatableConfig"
                :elements="interactiveMaps"
                :stripe="true"
                :draggable="false"
                :sst="true"
                :pagination="pagination"
                @action="handleAction"
                @filter="handleFilter"
            />
        </template>
    </DatatablePageLayout>
</template>

<script>

import { v4 as uuidv4 } from 'uuid';
import loader from "@/modules/Shared/Mixins/loader";
import DataTable from "@/modules/Shared/Components/table/SKDataTable.vue";
import PaginationService from "@/modules/Shared/Services/PaginationService";
import DatatablePageLayout from "@/modules/Shared/Pages/DatatablePageLayout.vue";
import InteractiveMapsService from "@/modules/Admin/Services/InteractiveMapsService";

export default {
    name: "InteractiveMapsPage",
    components: { DataTable, DatatablePageLayout },
    mixins: [loader],
    data() {
        return {
            interactiveMaps: [],
            datatableConfig: [
                { 'field' : 'name', head : this.$t('admin.interactive-maps.name'), 'searchable' : true, 'sortable' : false},
                { 'field' : 'url', head : this.$t('admin.interactive-maps.url'), 'searchable' : false, 'sortable' : false},
                { 'field' : 'actions', 'type': 'actions', head : this.$t("geofences.geofences-messages.actions"), 'searchable' : false, 'sortable' : false }
            ],
            pagination: {},
        }
    },
    async created() {
        await this.loadAndNotifyError(async () => {
            await this.getInteractiveMaps({
                filters: [],
                page: 1
            })
        })
    },
    methods: {
        async getInteractiveMaps(params) {
            const interactiveMapsResponse = await InteractiveMapsService.getInteractiveMaps(PaginationService.parseParameters(params))
            this.interactiveMaps = this.parseInteractiveMaps(interactiveMapsResponse.data)
            this.pagination = {
                per_page: interactiveMapsResponse.per_page,
                total: interactiveMapsResponse.total
            }
        },

        parseInteractiveMaps(interactiveMaps) {
            return interactiveMaps.map(interactiveMap => ({
                ...interactiveMap,
                actions: [ 'edit', 'delete' ]
            }))
        },

        async handleFilter(params) {
            await this.getInteractiveMaps(params)
        },

        async handleAction(type, uuid){
            switch(type) {
                case 'edit':
                    await this.$router.push({
                        name: 'admin-interactive-maps-edit',
                        params: { uuid: uuid }
                    })
                    break
                case 'delete':
                    await this.deleteInteractiveMap(uuid)
                    break
            }
        },

        async handleCreate() {
            await this.$router.push({
                name: 'admin-interactive-maps-edit',
                params: { uuid: uuidv4() }
            })
        },

        async deleteInteractiveMap(uuid) {
            await this.loadAndNotify(async () => {
                await InteractiveMapsService.deleteInteractiveMap(uuid)
                await this.getInteractiveMaps({ filters: [], page: 1 })
            })
        }
    }
};
</script>
